import React from 'react';

const NewSection = () => {
    return (
        <div>
            <div className='m-5'>
                <h2>A House Make better to set furniture</h2>
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSs5azHyBzBdksL4aKvlWhlVhHPEKM19sGfDg&usqp=CAU" alt="" />
            </div>
        </div>
    );
};

export default NewSection;